import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

/**
 * Substitui o MsalRedirectComponent do @azure/msal-angular, que chama
 * handleRedirectObservable() sem argumentos e portanto assume
 * navigateToLoginRequestUrl: true.
 *
 * Com redirectUri fixado na raiz, a URL de retorno ("/") e diferente da pagina onde o
 * login foi iniciado. Nesse caso o msal-browser nao processa a resposta na hora: ele
 * guarda o hash no cache temporario e navega para a pagina de origem, contando que ela
 * chame handleRedirectPromise de novo para consumir o hash cacheado. Se esse hash nao
 * sobrevive a navegacao extra, a resposta e descartada, o login e disparado outra vez e
 * o app entra em loop entre o redirect e o #code.
 *
 * Passando navigateToLoginRequestUrl: false a resposta e processada imediatamente no
 * redirectUri, sem navegacao intermediaria e sem depender do cache temporario. O custo
 * e que o usuario termina o login na raiz do app em vez de voltar para a rota de origem.
 *
 * O selector precisa continuar sendo `app-redirect`, que e o que o index.html usa.
 */
@Component({
  standalone: false,
  selector: 'app-redirect',
  template: ''
})
export class AuthRedirectComponent implements OnInit {

  constructor(private readonly authService: MsalService) { }

  ngOnInit(): void {
    this.authService.handleRedirectObservable({ navigateToLoginRequestUrl: false })
      .subscribe({
        error: error => console.error('Falha ao processar a resposta de autenticacao', error)
      });
  }

}
